import React from 'react'
import { data, useNavigate } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
import api from '../../config/axions.config';
import { toast } from 'sonner';
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import Swal from 'sweetalert2';
import { IoMdClose } from "react-icons/io";

const Students = () => {
  let navigate = useNavigate();
  var getInfo = localStorage.getItem('User') || "{}";
  let admin = JSON.parse(getInfo);
  const Permission = admin?.userRole?.permissions?.student || {}; // Using 'student' permissions
  const [admissionTypeList, setAdmissionTypeList] = useState([])
  const [courseList, setCourseList] = useState([])
  const [payment_typeList, setPayment_typeList] = useState([]);
  const [collageList, setCollageList] = useState([]);

  const [studentData, setStudentData] = useState([]);
  const [TableData, setTableData] = useState([]);

  const [isOpen, setIsOpen] = useState(false);
  const [isOpenCourse, setIsOpenCourse] = useState(false);
  // student data in the main......
  const [installmentList, setInstallmentList] = useState([]);
  const [studentFullData, setStudentFullData] = useState([]);

  // payment data in the from
  const [sellectedStudentData, setSellectedStudentData] = useState({});
  const [admission_type, setAdmission_type] = useState({
    type: "Please Chose Course",
    id: ""
  })
  const [course_id, setCourse_id] = useState('')
  const [payment_type, setPayment_type] = useState('');
  const [collage_id, setCollage_id] = useState('');
  const [installmentNo, setInstallmentNo] = useState(0)
  const [ScreenShort, setScreenShort] = useState({ Bytes: '', filename: '' })
  const [TransactionID, setTransactionID] = useState('');
  const [tutor, setTutor] = useState([]);
  const [totalAmount, setTotalAmount] = useState(null)
  const [paymentDate, setPaymentDate] = useState('');
  const [enrollmentId, setEnrollmentId] = useState('')
  const [courseId, setCourseId] = useState('');

  //enroll new course 
  const [startDateCourse, setStartDateCourse] = useState('');
  const [endDateCourse, setEndDateCourse] = useState('');
  const [duration, setDuration] = useState(null)
  const [totoalFee, setTotoalFee] = useState(null);
  const [installmentsCourse, setInstallmentsCourse] = useState(null)
  const [tutorFieldValue, setTutorFieldValue] = useState('');
  const [duration_type, setDuration_type] = useState('')
  // pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(8);

  async function getCollegList() {
    try {
      let responce = await api.get("collage")
      if (responce?.data.status) {
        setCollageList(responce.data.data.colleges);
      } else {
        toast.error(responce.data.message)
      }
    } catch (error) {
      console.log(error);
    }
  }
  async function getPaymentType() {
    try {
      let responce = await api.get("paymentType")
      if (responce?.data.status) {
        setPayment_typeList(responce.data.data.PaymentTypes);
      } else {
        toast.error(responce.data.message)
      }
    } catch (error) {
      console.log(error);
    }
  }
  async function getCourseList() {
    try {
      let responce = await api.get("course")
      if (responce?.data.status) {
        setCourseList(responce.data.data.courses);
      } else {
        toast.error(responce.data.message)
      }
    } catch (error) {
      console.log(error);
    }
  }

  const handleTutorFileKey = (e) => {
    if (e.key === "Enter") {
      if (tutorFieldValue) {
        tutor.push(tutorFieldValue);
        setTutorFieldValue('');
      }
      else {
        toast.error("input Language field")
      }
    }
  }
  const handleTutorListItemRemove = (e) => {
    let result = tutor.filter((item) => item !== e.target.id)
    setTutor(result);
  }

  async function getAdmissionType() {
    try {
      let responce = await api.get("admissionType")
      if (responce?.data.status) {
        setAdmissionTypeList(responce.data.data.AdmissionTypes);
      } else {
        toast.error(responce.data.message)
      }
    } catch (error) {
      console.log(error);
    }
  }
  const handleOpenPopup = () => {
    setIsOpen(true);
  }
  const handleOpenCoursePopup = (data) => {
    setSellectedStudentData(data)
    setIsOpenCourse(true);
  }
  const handleClosePopup = () => {
    setIsOpen(false);
  }
  const handleCloseCoursePopup = () => {
    setIsOpenCourse(false);
  }
  async function getStudentData() {
    try {
      let response = await api.get("student");
      if (response.status) {
        setStudentData(response.data.data)
        setTableData(response.data.data)
      } else {
        alert("someting is wrong data not get")
      }
    } catch (error) {
      console.log(error);
    }
  }
  // filter function 
  async function getStudentFilter() {
    try {
      let response = await api.get("student/collage-stream-filter", {
        params: {
          course: course_id,
          collage: collage_id,
          admission: admission_type,
        }
      })
      setStudentData(response.data?.data)
      setTableData(response.data?.data)
    } catch (error) {
      console.log(error);
      toast.error("Student not get Something is Wrong");
    }
  }
  // search student filter
  async function searchStudents(e) {
    let key = e.key
    let value = e.target.value
    if (key === "Enter") {
      try {
        let response = await api.get('student/search', {
          params: {
            search: value,
            course: course_id,
            collage: collage_id,
            admission: admission_type,
          }
        })
        if (response.data?.data.students?.length >= 0) {
          setTableData(response.data?.data?.students)
        }
      } catch (error) {
        console.log(error)
        toast.error(error.response.data?.message)
      }
    }
  }
  //  GET STUDENT FULL DATA FROM THE DB
  async function GetStudenFulltData(data) {
    try {
      setSellectedStudentData(data)
      let response = await api.get("enrollment/get-student-data", {
        params: { studentId: data?._id }
      });
      if (response) {
        setStudentFullData(response?.data.data);
        setIsOpen(true)
      }
      else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(error.response?.data.message)
    }
  }
  // STUDENT PAY FEE RECORD ADD API 
  async function addPaymentDetails(e) {
    Swal.fire({
      title: "You Collection Fee ?",
      text: "Do you Create new Fee Record",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#4CAF50",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Create."
    }).then(async (result) => {
      if (result.isConfirmed) {
        if (!enrollmentId || !payment_type || !paymentDate || !installmentNo || !totalAmount || !TransactionID) toast.error("Some fileds are emplty");
        try {
          const formData = new FormData();
          formData.append("student_id", sellectedStudentData._id);
          formData.append("enrolment_id", enrollmentId);
          formData.append("installment", installmentNo);
          formData.append("payment_type", payment_type);
          formData.append("payment_date", paymentDate);
          formData.append("transactionID", TransactionID);
          formData.append("total_amount", totalAmount);
          formData.append("admissionType", admission_type.id);
          formData.append("course", courseId);
          formData.append("created_by", admin._id);
          if (ScreenShort.filename) formData.append("screenShort", ScreenShort.Bytes);

          let responce = await api.post('feecollection', formData);
          if (responce.data.status) {
            toast.success(responce.data.message);
          }
          else {
            toast.error(responce.data.message);
          }

        } catch (error) {
          toast.error(error.response.data.message);
          let list = error.response.data.errors || [];
          for (let item of list) {
            toast.warning(item.msg)
          }
        }
      } else {
        toast.error("OK! request cancle.")
      }
    });
  }
  // student enrollment function
  async function submitEnrollment() {
    Swal.fire({
      title: "Create New Enrollment?",
      text: "Do you want to Create new Enrollment",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#4CAF50",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Create."
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          if (!tutor || !installmentsCourse || !duration || !admission_type || !course_id || !totoalFee || startDateCourse || endDateCourse || duration_type) toast.error("Some fileds are emplty");
          const responce = await api.post('enrollment', { student_id: sellectedStudentData._id, admission_type: admission_type.id, course_id, tutor, no_of_installments: installmentsCourse, start_date: startDateCourse, end_date: endDateCourse, total_fee: totoalFee, duration, enrolled_by: admin._id, duration_type });
          if (responce.data.status) {
            toast.success(responce.data.message);
            setIsOpenCourse(false)
          }
          else {
            toast.error(responce.data.message);
          }
        } catch (error) {
          toast.error(error.response.data.message);
          let list = error.response.data.errors || [];
          for (let item of list) {
            toast.warning(item.msg)
          }
        }
      } else {
        toast.error("OK! request cancle.");
      }
    });
  }
  // Use Effect
  useEffect(() => {
    getStudentData();
    getCourseList();
    getAdmissionType();
    getPaymentType();
    getCollegList()
  }, [])

  // pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = TableData?.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(TableData.length / itemsPerPage);

  // **Page Change Handler**
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const inputRefDate = useRef();
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;

  /* Logic between end date and duration By Date*/
  useEffect(() => {
    if (startDateCourse && duration > 0 && duration_type) {
      const start = new Date(startDateCourse);
      if (duration_type === "months") {
        start.setMonth(start.getMonth() + parseInt(duration)); // Adding the duration in months
      } else if (duration_type === "days") {
        start.setDate(start.getDate() + parseInt(duration)); // Adding the duration in days
      }
      setEndDateCourse(start.toISOString().split('T')[0]); // Format to YYYY-MM-DD
    } else {
      setEndDateCourse(''); // Clear end date if inputs are invalid
    }
  }, [startDateCourse, duration, duration_type]);

  return (
    <div>
      <div className='grow ms-0 md:ms-0 lg:ms-56 relative'>
        {
          isOpen && (
            <div className='bg-black bg-opacity-50 absolute w-full h-full z-[999]'>
              <div>
                <div id="addNewCourseModal" aria-labelledby="modal-title" role="dialog" aria-hidden="true" tabIndex="-1">
                  <div className="modal-overlay" tabIndex="-1"></div>
                  <div className="modal-dialog modal-dialog-scrollable md:max-w-3xl xl:max-w-4xl">
                    <div className="modal-content" role="document">
                      <div className="modal-header">
                        <h5 className="mr-12 text-lg font-bold truncate">
                          Payment Collection
                        </h5>

                        <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close" onClick={handleClosePopup}>
                          <span className="sr-only">
                            Close
                          </span>
                          <svg className="w-6 h-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                          </svg>
                        </button>
                      </div>

                      <div className="modal-body">
                        <form action="#" method="POST">
                          <div className="grid grid-cols-2 sm:grid-cols-4 gap-x-5 gap-y-4">
                            <div className="col-span-2">
                              <label htmlFor="">
                                Student Name
                              </label>
                              <div className="mt-1 ">
                                <input type="text" value={`${sellectedStudentData.firstname}  ${sellectedStudentData.lastname}`} />
                              </div>
                            </div>

                            <div className="col-span-2">
                              <label htmlFor="">
                                Student Id
                              </label>
                              <div className="mt-1 ">
                                <input type="text" value={sellectedStudentData._id} />
                              </div>
                            </div>

                            <div className="col-span-2">
                              <label htmlFor="">
                                Student Contact
                              </label>
                              <div className="mt-1 ">
                                <input type="text" value={sellectedStudentData.mobile} />
                              </div>
                            </div>

                            {/* student select enrollment */}
                            <div className="col-span-2 sm:col-span-4 md:col-span-2">
                              <label htmlFor="">
                                Course <span className="text-primary-600">*</span>
                              </label>
                              <div className="mt-1">
                                <select onChange={(e) => {
                                  setEnrollmentId(e.target.value);
                                  setCourseId(e.target.selectedOptions[0].getAttribute('courseID'));
                                  setAdmission_type({
                                    id: e.target.selectedOptions[0].getAttribute('admissionTypeId'), type: e.target.selectedOptions[0].getAttribute('admissionTypeName')
                                  })
                                }} >
                                  <option value={null}>
                                    {"Please choose Course"}
                                  </option>
                                  {
                                    studentFullData?.map(item => (
                                      <option value={item._id} courseID={item.courseData._id} admissionTypeId={item.admissionType._id} admissionTypeName={item.admissionType.type} >
                                        {item.courseData.name}
                                      </option>
                                    ))
                                  }
                                </select>
                              </div>
                            </div>

                            <div className="col-span-2 sm:col-span-4 md:col-span-2">
                              <label htmlFor="">
                                Admission Type <span className="text-primary-600">*</span>
                              </label>
                              <div className="mt-1">
                                <input type="text" value={admission_type.type} />
                              </div>
                            </div>

                            <div className="col-span-2 sm:col-span-4 md:col-span-2">
                              <label htmlFor="">
                                Payment Type <span className="text-primary-600">*</span>
                              </label>
                              <div className="mt-1">
                                <select onChange={(e) => setPayment_type(e.target.value)} >
                                  <option value={null}>
                                    {"Please choose Payment Type"}
                                  </option>
                                  {
                                    payment_typeList?.filter((item) => item.is_active === true)?.map(item => (
                                      <option value={item._id}>
                                        {item.type}
                                      </option>
                                    ))
                                  }
                                </select>
                              </div>
                            </div>

                            <div className="col-span-2">
                              <label htmlFor="">
                                Payment Date
                              </label>
                              <div className="mt-1 ">
                                <input type="date" value={paymentDate} onChange={(e) => setPaymentDate(e.target.value)} />
                              </div>
                            </div>

                            <div className="col-span-2">
                              <label htmlFor="">
                                Total Amount
                              </label>
                              <div className="mt-1">
                                <div className="relative rounded-md shadow-sm">
                                  <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                                    <span className="text-gray-500 sm:text-sm">
                                      &#8377;
                                    </span>
                                  </div>
                                  <input type="number" value={totalAmount} onChange={(e) => setTotalAmount(e.target.value)} className="!pl-7 !pr-12" required />
                                  <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                                    <span className="text-gray-500 sm:text-sm">
                                      RS
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="col-span-2">
                              <label htmlFor="">
                                Installments
                              </label>
                              <div className="mt-1 ">
                                <input type="text" value={installmentNo} onChange={(e) => setInstallmentNo(e.target.value)} />
                              </div>
                            </div>

                            {payment_type === "67ce808f38f89d08017195d1" ? ""
                              :
                              (<div className="col-span-2 sm:col-span-4">
                                <label htmlFor="">
                                  Upload Screenshot
                                </label>
                                <div className="mt-1">
                                  <div className='flex'>
                                    <input type="file" className='' onChange={(e) => setScreenShort({ Bytes: e.target.files[0], filename: URL.createObjectURL(e.target.files[0]) })} />
                                    <img src={ScreenShort.filename} alt='Screenshot' className='w-1/6' />
                                  </div>
                                </div>
                              </div>)
                            }

                            {payment_type === "67ce808f38f89d08017195d1" ? ""
                              :
                              (<div className="col-span-4">
                                <label htmlFor="">
                                  {payment_type === "67aafcf0e4c3382b848d9abb" ? "Cheque No." : "Transaction Id"}
                                </label>
                                <div className="mt-1 ">
                                  <input type="text" value={TransactionID} onChange={(e) => setTransactionID(e.target.value)} />
                                </div>
                              </div>)
                            }
                          </div>
                        </form>
                      </div>

                      <div className="modal-footer">
                        <div className="flex items-center justify-end space-x-4">
                          <button type="button" className="btn btn-light" data-dismiss="modal" aria-label="Close Modal">
                            Discard
                          </button>
                          <button type="button" onClick={addPaymentDetails} className="btn btn-primary">
                            Save
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          )
        }
        {
          isOpenCourse && (
            <div className='bg-black bg-opacity-50 absolute w-full h-full z-[999]'>
              <div id="addNewCourseModal" aria-labelledby="modal-title" role="dialog" aria-hidden="true" tabIndex="-1">
                <div className="modal-overlay" tabIndex="-1"></div>
                <div className="modal-dialog modal-dialog-scrollable md:max-w-4xl xl:max-w-5xl">
                  <div className="modal-content" role="document">
                    <div className="modal-header">
                      <h5 className="mr-12 text-lg font-bold truncate">
                        Enroll New Course
                      </h5>

                      <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close" onClick={handleCloseCoursePopup}>
                        <span className="sr-only">
                          Close
                        </span>
                        <svg className="w-6 h-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 24 24" stroke="currentColor" aria-hidden="true">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                      </button>
                    </div>

                    <div className="modal-body pb-10">
                      <form action="#" method="POST">
                        <div className="grid grid-cols-2 sm:grid-cols-4 gap-x-5 gap-y-4">
                          <div className="col-span-2">
                            <label htmlFor="">
                              Student Name
                            </label>
                            <div className="mt-1 ">
                              <input type="text" value={`${sellectedStudentData.firstname}  ${sellectedStudentData.lastname}`} />
                            </div>
                          </div>

                          <div className="col-span-2">
                            <label htmlFor="">
                              Student Id
                            </label>
                            <div className="mt-1 ">
                              <input type="text" value={sellectedStudentData._id} />
                            </div>
                          </div>

                          <div className="col-span-2">
                            <label htmlFor="">
                              Student Contact
                            </label>
                            <div className="mt-1 ">
                              <input type="number" value={sellectedStudentData.mobile} />
                            </div>
                          </div>

                          <div className="col-span-2 sm:col-span-4 md:col-span-2">
                            <label htmlFor="">
                              Admission Type <span className="text-primary-600">*</span>
                            </label>
                            <div className="mt-1">
                              <select onChange={(e) => { setAdmission_type(e.target.value, e.target.selectedOptions[0].getAttribute('type')); setAdmission_type({ id: e.target.value, type: e.target.selectedOptions[0].getAttribute('type') }) }} >
                                <option value={admission_type.id}>
                                  {admission_type.type}
                                </option>
                                {
                                  admissionTypeList?.map(item => (
                                    <option key={item._id} value={item._id} type={item.type} >
                                      {item.type}
                                    </option>
                                  ))
                                }
                              </select>
                            </div>
                          </div>

                          <div className="col-span-2 sm:col-span-4 md:col-span-2">
                            <label htmlFor="">
                              Course <span className="text-primary-600">*</span>
                            </label>
                            <div className="mt-1">
                              <select onChange={(e) => { setCourse_id(e.target.value); setDuration(e.target.selectedOptions[0].getAttribute('duration')); setTutorFieldValue(e.target.selectedOptions[0].getAttribute("tutor")); setTotoalFee(e.target.selectedOptions[0].getAttribute("total_fee")); setDuration_type(e.target.selectedOptions[0].getAttribute('duration_type')) }} >
                                <option value={null}>
                                  {"Please chose Admission Type"}
                                </option>
                                {
                                  courseList?.filter((item) => item.admissionType === admission_type.id)?.map(item => (
                                    <option value={item._id} tutor={item.tutor} duration={item.duration} total_fee={item.base_fee} duration_type={item.duration_type}>
                                      {item.name}
                                    </option>
                                  ))
                                }
                              </select>
                            </div>
                          </div>

                          <div className="col-span-1 sm:col-span-1 md:col-span-1">
                            <label htmlFor="">
                              Duration Type
                            </label>
                            <div className="mt-1">
                              <select name="" id="" onChange={(e) => setDuration_type(e.target.value)}>
                                <option value="">
                                  {duration_type}
                                </option>
                                <option value="days">
                                  Days
                                </option>
                                <option value="months">
                                  Months
                                </option>
                              </select>
                            </div>
                          </div>

                          <div className="col-span-1 sm:col-span-1 md:col-span-1">
                            <label htmlFor="">
                              Course Duration
                            </label>
                            <div className="mt-1">
                              <input type="number" value={duration} onChange={(e) => { setDuration(e.target.value) }} />
                            </div>
                          </div>

                          <div className="col-span-2">
                            <label htmlFor="">
                              Total Fees
                            </label>
                            <div className="mt-1">
                              <div className="relative rounded-md shadow-sm">
                                <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                                  <span className="text-gray-500 sm:text-sm">
                                    &#8377;
                                  </span>
                                </div>
                                <input type="number" value={totoalFee} onChange={(e) => setTotoalFee(e.target.value)} placeholder="Total Fee" className="!pl-7 !pr-12" required />
                                <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                                  <span className="text-gray-500 sm:text-sm">
                                    RS
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-span-2 sm:col-span-4 md:col-span-2">
                            <label htmlFor="">
                              Enrolled By <span className="text-primary-600">*</span>
                            </label>
                            <div className="mt-1">
                              <input type="text" value={admin.firstname + " " + admin.lastname} className="" />
                            </div>
                          </div>

                          <div className="col-span-2">
                            <label htmlFor="">
                              Start Date
                            </label>
                            <div className="mt-1 ">
                              <input type="date" value={startDateCourse} onChange={(e) => setStartDateCourse(e.target.value)} />
                            </div>
                          </div>

                          <div className="col-span-2">
                            <label htmlFor="">
                              End Date
                            </label>
                            <div className="mt-1 ">
                              <input type="date" value={endDateCourse} /*  onChange={(e) => setEndDateCourse(e.target.value)} */ />
                            </div>
                          </div>

                          <div className="col-span-2 sm:col-span-4 md:col-span-2">
                            <label htmlFor="">
                              Tutor
                            </label>
                            <div className="mt-1">
                              <input type="text" value={tutorFieldValue} onChange={(e) => setTutorFieldValue(e.target.value)} onKeyDown={(e) => handleTutorFileKey(e)} />
                              <div className='w-full p-2 my-1 mb-2 flex-1 sm:text-sm rounded-md flex flex-wrap gap-2 overflow-hidden !absolute'>
                                {
                                  tutor?.map((item, index) => <p key={index} className='px-2 items-center gap-1 flex justify-center bg-sky-200  rounded-3xl' >{item}<IoMdClose id={item} onClick={(e) => handleTutorListItemRemove(e)} width={"10px"} /></p>)
                                }
                              </div>
                            </div>
                          </div>

                          <div className="col-span-2">
                            <label htmlFor="">
                              Installments
                            </label>
                            <div className="mt-1 ">
                              <input type="number" value={installmentsCourse} onChange={(e) => setInstallmentsCourse(e.target.value)} />
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>

                    <div className="modal-footer">
                      <div className="flex items-center justify-end space-x-4">
                        <button type="button" className="btn btn-light" data-dismiss="modal" aria-label="Close Modal">
                          Discard
                        </button>
                        <button type="button" onClick={submitEnrollment} className="btn btn-primary">
                          Save
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        }
        <div className="px-4 mt-6 mb-8 sm:px-6 lg:px-8">
          <div className='flex items-center justify-end lg:justify-between'>
            <h1 className="hidden text-2xl font-semibold text-primary-600 lg:block">
              Students
            </h1>

            <div className='flex gap-3'>
              {/* <button type="button" onClick={handleOpenCoursePopup} className="w-full btn sm:w-auto btn-primary leading-icon mb-5 md:mb-5 lg:mb-0" data-toggle="modal" data-target="#addClassModal">
                <svg stroke="currentColor" viewBox="0 0 256 256">
                  <line x1="40" y1="128" x2="216" y2="128" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="24"></line>
                  <line x1="128" y1="40" x2="128" y2="216" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="24"></line>
                </svg>
                Enroll in New Course
              </button> */}

              <button type="button" onClick={() => navigate('add-students')} className="w-full btn sm:w-auto btn-primary leading-icon mb-5 md:mb-5 lg:mb-0" data-toggle="modal" data-target="#addClassModal">
                <svg stroke="currentColor" viewBox="0 0 256 256">
                  <line x1="40" y1="128" x2="216" y2="128" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="24"></line>
                  <line x1="128" y1="40" x2="128" y2="216" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="24"></line>
                </svg>
                Add New Students
              </button>
            </div>
          </div>

          <div className="space-y-6 lg:mt-6">
            <div className="overflow-hidden bg-white rounded-lg shadow">
              <div className="px-4 py-5 flex justify-between sm:px-6">
                <div className="flex justify-between">
                  <div className='flex'>
                    <div className='max-w-lg'>
                      <label htmlFor="searchStudents" className="sr-only">
                        Search Students
                      </label>
                      <div className="relative rounded-md">
                        <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                          <svg className="w-5 h-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                          </svg>
                        </div>
                        <input type="text" onKeyDown={(e) => searchStudents(e)} autoComplete="off" name="searchStudents" id="searchStudents" className="block w-full pr-4 py-2.5 rounded-lg focus:border-primary-600 focus:ring-primary-600 border border-gray-200 shadow-sm !pl-10" placeholder="Search student by name, email, phone or address..." />
                      </div>
                    </div>

                    <div className="flex items-center ml-4 space-x-2">
                      <select onChange={(e) => setCourse_id(e.target.value)} >
                        <option value={null}>
                          {"Course"}
                        </option>
                        {
                          courseList?.map(item => (
                            <option value={item._id} key={item._id}>
                              {item.name}
                            </option>
                          ))
                        }
                      </select>
                    </div>

                    <div className="flex items-center ml-4 space-x-2">
                      <select name="" id="" className="" onClick={(e) => setCollage_id(e.target.value)} required>
                        <option value={null} >
                          {"College"}
                        </option>
                        {
                          collageList?.map(item => (
                            <option key={item._id} value={item._id}>
                              {item.name}{" "}{item.city}
                            </option>
                          ))
                        }
                      </select>
                    </div>

                    <div className='flex items-center ml-4 space-x-2'>
                      <select onChange={(e) => setAdmission_type(e.target.value)} >
                        <option value={null}>
                          {"Admission Type"}
                        </option>
                        {
                          admissionTypeList?.map(item => (
                            <option key={item._id} value={item._id}>
                              {item.type}
                            </option>
                          ))
                        }
                      </select>
                    </div>

                    <div className="flex items-center ml-4 space-x-2">
                      <select name="" id="">
                        <option value="">
                          Status
                        </option>
                        <option value="active">
                          Active
                        </option>
                        <option value="deactive">
                          Deactive
                        </option>
                        <option value="pending">
                          Pending
                        </option>
                      </select>
                    </div>

                    <div className="flex items-center ml-4 space-x-2">
                      <DatePicker
                        selectsRange={true}
                        ref={inputRefDate}
                        startDate={startDate}
                        dateFormat="dd/MM/yyyy"
                        endDate={endDate}
                        onChange={(update) => {
                          setDateRange(update);
                        }}
                        isClearable={true}
                        placeholderText="Custom Date"
                      />
                    </div>
                  </div>
                  <div className='ml-4'>
                    <button onClick={getStudentFilter} className='btn btn-primary'>
                      Search
                    </button>
                  </div>
                </div>

              </div>

              <div className="flex flex-col">
                <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                  <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                    <div className="overflow-hidden">
                      <table className="custom-table">
                        <thead>
                          <tr>
                            <th scope="col">
                              Student Name
                            </th>
                            <th scope="col" className="">
                              Student Id
                            </th>
                            <th scope="col" className="">
                              Contact
                            </th>
                            <th scope="col" className="">
                              Email
                            </th>
                            <th scope="col" className="">
                              Course
                            </th>
                            <th scope="col" className="">
                              Gender
                            </th>
                            <th scope="col" className="">
                              Status
                            </th>
                            <th scope="col" className="">
                              Add Course
                            </th>
                            <th scope="col" className="">
                              Pay
                            </th>
                            <th scope="col" className="">
                              Action
                            </th>
                          </tr>
                        </thead>

                        <tbody>
                          {
                            TableData?.length === 0 ?
                              <tr className='flex p-2'>
                                <td className='dark:text-white text-black text-2xl w-full text-center'>Student Is Loading...........</td>
                              </tr>
                              :
                              currentItems?.map(item => (
                                <tr key={item._id}>
                                  <td>
                                    <div className="flex items-center">
                                      <button type="button" className="cursor-move hover:text-primary-600 !pr-3">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 8h16M4 16h16" />
                                        </svg>
                                      </button>
                                      <div className="flex-1 min-w-0 ml-2">
                                        <div title="" className="font-medium truncate hover:text-primary-600 w-36 sm:w-auto line-clamp-1">
                                          {item.firstname}&nbsp;{item.lastname}
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                  <td className="">
                                    {item._id.split("").slice(20, 24)}
                                  </td>
                                  <td className="">
                                    {item.mobile}
                                  </td>
                                  <td className="">
                                    {item.email}
                                  </td>
                                  <td className="">
                                    {item?.enrollmentsData?.map(item=> `${item?.courseDetail?.name} |  `)}
                                  </td>
                                  <td className="">
                                    {item.gender}
                                  </td>
                                  <td className="">
                                    {item?.is_active ?
                                      (<span className='px-4 py-3 bg-green-500 rounded-md text-white text-center'>Active</span>)
                                      :
                                      (<span className='px-2 py-3 bg-red-500 rounded-md text-white text-center'>Deactive</span>)}
                                  </td>
                                  <td className="">
                                    <button type="button" className="btn btn-primary px-6" onClick={() => handleOpenCoursePopup(item)}>
                                      Add
                                    </button>
                                  </td>
                                  <td className="">
                                    <button type="button" className="btn btn-primary px-6" onClick={() => { GetStudenFulltData(item) }}>
                                      Pay
                                    </button>
                                  </td>
                                  <td>
                                    <div className="">
                                      <div className="dropdown xl:hidden">
                                        <button type="button" className="btn-cricle dropdown-toggle" data-toggle="dropdown" id="dropdownMenuButton" aria-haspopup="true" aria-expanded="true">
                                          <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 256 256">
                                            <circle cx="128" cy="128" r="16"></circle>
                                            <circle cx="64" cy="128" r="16"></circle>
                                            <circle cx="192" cy="128" r="16"></circle>
                                          </svg>
                                        </button>

                                        <div className="dropdown-menu" role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabIndex="-1">
                                          <div className="divide-y divide-gray-100">
                                            <div className="py-1" role="none">
                                              <div title="View Class Details" className="dropdown-item" role="menuitem" tabIndex="-1">
                                                View
                                              </div>
                                              <div title="Edit Class" className="dropdown-item" role="menuitem" tabIndex="-1">
                                                Edit
                                              </div>
                                              <div title="Delete Class" className="dropdown-item" role="menuitem" tabIndex="-1">
                                                Delete
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>

                                      <div title="View Class Details" className="hidden btn-circle xl:inline-flex" aria-label="View" data-microtip-position="top" data-target="tooltip" role="button" onClick={() => navigate('/dashboard/students/view-students', { state: item })}>
                                        <svg className="w-5 h-5" stroke="currentColor" viewBox="0 0 256 256">
                                          <path d="M128,55.99219C48,55.99219,16,128,16,128s32,71.99219,112,71.99219S240,128,240,128,208,55.99219,128,55.99219Z" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="24"></path>
                                          <circle cx="128" cy="128" r="32" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="24"></circle>
                                        </svg>
                                      </div>

                                      <div title="Edit Class" className="hidden btn-circle xl:inline-flex" aria-label="Edit" data-microtip-position="top" data-target="tooltip" role="button" onClick={() => navigate('/dashboard/students/edit-students', { state: item })}>
                                        <svg className="w-5 h-5" stroke="currentColor" viewBox="0 0 256 256">
                                          <path d="M92.68629,216H48a8,8,0,0,1-8-8V163.31371a8,8,0,0,1,2.34315-5.65686l120-120a8,8,0,0,1,11.3137,0l44.6863,44.6863a8,8,0,0,1,0,11.3137l-120,120A8,8,0,0,1,92.68629,216Z" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="24"></path>
                                          <line x1="136" y1="64" x2="192" y2="120" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="24"></line>
                                          <line x1="44" y1="156" x2="100" y2="212" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="24"></line>
                                        </svg>
                                      </div>

                                      <div title="Delete Class" className="hidden btn-circle xl:inline-flex" aria-label="Delete" data-microtip-position="top" data-target="tooltip" role="button">
                                        <svg className="w-5 h-5" stroke="currentColor" viewBox="0 0 256 256">
                                          <rect width="256" height="256" fill="none"></rect>
                                          <line x1="215.99609" y1="60" x2="39.99609" y2="60.00005" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="24"></line>
                                          <line x1="104" y1="104" x2="104" y2="168" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="24"></line>
                                          <line x1="152" y1="104" x2="152" y2="168" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="24"></line>
                                          <path d="M200,60V208a8,8,0,0,1-8,8H64a8,8,0,0,1-8-8V60" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="24"></path>
                                          <path d="M168,60V36a16,16,0,0,0-16-16H104A16,16,0,0,0,88,36V60" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="24"></path>
                                        </svg>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              ))
                          }
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <div className="px-4 py-5 bg-white border-t border-gray-200 sm:px-6">
                <div className="px-4 bg-white border-gray-200">
                  <div className="flex justify-between items-center">
                    <div>
                      <p className="text-sm text-gray-700">
                        Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, TableData.length)} of {TableData.length} results
                      </p>
                    </div>
                    <div className='flex space-x-5'>
                      <div className="flex items-center ml-8 space-x-2">
                        <span>
                          Show
                        </span>
                        <select onChange={(e) => setItemsPerPage(e.target.value)}>
                          <option value="10">
                            10
                          </option>
                          <option value="9">
                            9
                          </option>
                          <option value="8">
                            8
                          </option>
                          <option value="7">
                            7
                          </option>
                          <option value="6">
                            6
                          </option>
                          <option value="5">
                            5
                          </option>
                        </select>
                        <span>
                          records
                        </span>
                      </div>
                      <div className="flex">
                        {/* Previous Button */}
                        <button onClick={() => handlePageChange(currentPage - 1)}
                          disabled={currentPage === 1}
                          className={`inline-flex items-center px-2 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-l-lg hover:bg-gray-50 ${currentPage === 1 ? 'text-gray-400' : 'text-black'}`}>
                          <svg className="w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                            <path fillRule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clipRule="evenodd" />
                          </svg>
                        </button>

                        {/* Page Numbers */}
                        {[...Array(totalPages).keys()].map((num) => {
                          const pageNumber = num + 1;
                          const firstPageToShow = Math.max(1, currentPage - 1);
                          const lastPageToShow = Math.min(totalPages, currentPage + 1);

                          if (pageNumber >= firstPageToShow && pageNumber <= lastPageToShow) {
                            return (
                              <button
                                key={pageNumber}
                                onClick={() => handlePageChange(pageNumber)}
                                className={`inline-flex items-center px-4 py-2 text-sm font-medium border text-gray-500 ${currentPage === pageNumber ? 'bg-primary-100 border-primary-600 text-primary-600' : 'text-black'}`}>
                                {pageNumber}
                              </button>
                            );
                          }
                          return null; // Skip pages outside of the current window
                        })}

                        {/* Next Button */}
                        <button onClick={() => handlePageChange(currentPage + 1)}
                          disabled={currentPage === totalPages}
                          className={`inline-flex items-center px-2 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-r-lg hover:bg-gray-50 ${currentPage === totalPages ? 'text-gray-400' : 'text-black'}`}>
                          <svg className="w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                            <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Students
